import { MetricGroupPath } from './metricsGroupUtils';

function getMetricDescription(
  path: MetricGroupPath | null
) {
  return path ? `${path.input.firstNode.attributes.name} / ${path.input.secondNode.attributes.name}`.toLocaleLowerCase() : '';
}

export default getMetricDescription;
